module.exports = __webpack_public_path__ + "static/media/underline.953e6cdf.svg";